var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemModalFormElement_1;
import { CustomElement, Defaults, P, PCSS, Watch, PropertyConverters, ViewChild, Utils, Net, avoidHandler } from '@pacem/pacem-core';
import { Components as UIComponents } from '@pacem/pacem-ui';
import { Components as ScaffoldingComponents } from '@pacem/pacem-scaffolding';
const UI = UIComponents.UI;
//namespace Pacem.Components.Plus {
// TODO: use onewaytosource as a binding mode
let PacemModalFormElement = PacemModalFormElement_1 = class PacemModalFormElement extends UI.PacemDialogBase {
    get form() {
        return this._form;
    }
    constructor() {
        super();
        this.suddenValidation = true;
        this.method = Net.HttpMethod.Post;
        this._keyupHandler = (evt) => {
            if (evt.keyCode === /* Enter */ 13
                // no modifiers
                && !evt.shiftKey && !evt.ctrlKey && !evt.altKey && !evt.metaKey) {
                let btn = evt.currentTarget.querySelector(`.${PCSS}-dialog-buttons ${P}-button[type=submit]`);
                if (!Utils.isNull(btn) && Utils.isVisible(btn) && !btn.disabled) {
                    btn.click();
                }
            }
        };
        this.#keepStateOnCommit = false;
        this._emitter = new ScaffoldingComponents.Scaffolding.FormEventEmitter(this);
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        // HACK: move the buttons outside the .pacem-scrollable element in the lightbox
        //var lightboxCore = this.querySelector(`.${PCSS}-lightbox`);
        //lightboxCore.appendChild(
        //    this._buttons = this.querySelector(`.${PCSS}-dialog-buttons`)
        //);
        //lightboxCore.appendChild(
        //    this.querySelector(`.${PCSS}-dialog-heading`)
        //);
        //lightboxCore.appendChild(
        //    this.querySelector(P + '-loader')
        //);
        //this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'modalButtons', currentValue: this.modalButtons }));
        this.addEventListener('keyup', this._keyupHandler, false);
        this._emitter.start();
    }
    disconnectedCallback() {
        this._emitter.stop();
        this.removeEventListener('keyup', this._keyupHandler, false);
        super.disconnectedCallback();
    }
    _submit(evt) {
        if (this.readonly) {
            this.commit(UI.DialogButton.Ok, evt);
        }
        else {
            avoidHandler(evt);
            this._form.validate().then(valid => {
                if (valid) {
                    if (Utils.isNullOrEmpty(this.action)) {
                        this.commit(UI.DialogButton.Ok, evt);
                    }
                    else {
                        this._form.submit(this._fetcher).then(_ => {
                            this.commit(UI.DialogButton.Ok, evt);
                        }, r => {
                            // do nothing
                        });
                    }
                }
            });
        }
    }
    _onSubmit(evt) {
        // no need to broadcast, event bubbles itself...
        // ...just handle it using the eventual listeners:
        this.emit(evt);
    }
    #keepStateOnCommit;
    open(state, keepStateOnCommit, setAsPristine = true) {
        if (Utils.isNull(state)) {
            throw `The state of a ${PacemModalFormElement_1} cannot be null.`;
        }
        this.#keepStateOnCommit = keepStateOnCommit;
        var retval = super.open(state);
        if (setAsPristine) {
            this._form.setPristine();
        }
        return retval;
    }
    commit(btn, evt) {
        super.commit(btn, evt);
        if (!this.#keepStateOnCommit) {
            Utils.waitForAnimationEnd(this, 500).then(_ => {
                // BREAKING change (v0.8.37): state destroyed when dialog committed
                // TODO: consider 'if' and 'how' to avoid this.
                this.state = {};
            });
        }
    }
    _cancel(evt) {
        this.commit(UI.DialogButton.Cancel, evt);
        this._form.reset();
    }
    _broadcast(evt) {
        this.dispatchEvent(new CustomEvent(evt.type, { detail: evt.detail }));
    }
    /** Gets the 'ok' and 'cancel' modal buttons. */
    get modalButtons() {
        const btns = this._buttons;
        return {
            ok: btns && btns.firstElementChild && btns.firstElementChild.firstElementChild,
            cancel: btns && btns.firstElementChild && btns.firstElementChild.lastElementChild
        };
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemModalFormElement.prototype, "suddenValidation", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.String })
], PacemModalFormElement.prototype, "okCaption", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.String })
], PacemModalFormElement.prototype, "cancelCaption", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.String })
], PacemModalFormElement.prototype, "method", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemModalFormElement.prototype, "metadata", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemModalFormElement.prototype, "action", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemModalFormElement.prototype, "loaderType", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemModalFormElement.prototype, "success", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemModalFormElement.prototype, "fail", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemModalFormElement.prototype, "readonly", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemModalFormElement.prototype, "fetchHeaders", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemModalFormElement.prototype, "fetchCredentials", void 0);
__decorate([
    ViewChild(P + '-lightbox')
], PacemModalFormElement.prototype, "lightbox", void 0);
__decorate([
    ViewChild(P + '-form[entity]')
], PacemModalFormElement.prototype, "_form", void 0);
__decorate([
    ViewChild(P + '-fetch')
], PacemModalFormElement.prototype, "_fetcher", void 0);
PacemModalFormElement = PacemModalFormElement_1 = __decorate([
    CustomElement({
        tagName: P + '-modal-form', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-lightbox modal="true" logger="{{ :host.logger }}">
        <${P}-form wrapper>
            <${P}-form logger="{{ :host.logger }}" on-submit=":host._onSubmit($event)" readonly="{{ :host.readonly }}" entity="{{ :host.state, twoway }}" on-success=":host._broadcast($event)"
                on-fail=":host._broadcast($event)" success="{{ :host.success, twoway }}" fail="{{ :host.fail, twoway }}" autogenerate="{{ !$pacem.isNull($this.entity) }}" metadata="{{ :host.metadata }}"
                fetch-headers="{{ :host.fetchHeaders }}" fetch-credentials="{{ :host.fetchCredentials }}" sudden-validation="{{ :host.suddenValidation }}"></${P}-form>
        </${P}-form>
        <${P}-fetch logger="{{ :host.logger }}" method="{{ :host.method }}" headers="{{ :host.fetchHeaders }}" credentials="{{ :host.fetchCredentials }}" autofetch="false" url="{{ :host.action }}"></${P}-fetch>
    <div class="${PCSS}-dialog-buttons ${PCSS}-buttonset buttons" slot="bottom">
        <div class="buttonset-left">
        <${P}-button on-click=":host._submit($event)" css-class="{{ {'buttonset-last': :host.readonly} }}" type="submit"
            class="button primary button-size size-small" disabled="{{ (:host.suddenValidation && !:host.readonly && !(::_form.valid && ::_form.dirty)) || ::_fetcher.fetching }}">
            <${P}-panel class="submit-spinner ${PCSS}-anim anim-pop" hide="{{ !::_form.fetching }}"><i class="${PCSS}-icon ${PCSS}-anim anim-rotate rotate-uniform display-block">refresh</i></${P}-panel>
            <${P}-text text="{{ :host.okCaption || 'OK' }}"></${P}-text>
        </${P}-button>
        <${P}-button on-click=":host._cancel($event)" hide="{{ :host.readonly }}" class="button button-size size-small" disabled="{{ ::_fetcher.fetching }}"><${P}-text text="{{ :host.cancelCaption || 'Cancel' }}"></${P}-text></${P}-button>
    </div></div>
    <div class="${PCSS}-dialog-heading" slot="top">
        <${P}-content></${P}-content>
    </div>
    <div class="pos-absolute absolute-top absolute-right absolute-left absolute-bottom overflow-hidden ${PCSS}-inert display-flex flex-center flex-middle">
        <${P}-loader type="{{ :host.loaderType }}" class="loader-primary loader-smaller ${PCSS}-anim anim-pop" active="{{ ::_fetcher.fetching }}"></${P}-loader>
    </div>
</${P}-lightbox>`
    })
], PacemModalFormElement);
export { PacemModalFormElement };
